<template>
  <div class="estimation">
  <div class="modal-background">
    <div class="modal-wrapper" :class="[$mq, {TA:isTestAchat}]">
      <div class="modal">
        <h1>
          {{ $t('Situation.Consumption.consumptionUnknown.title') }}
          <span class="close" @click="close()"></span>
        </h1>
        <SimulationField
          :label="$t('Situation.Consumption.consumptionUnknown.people')"
          v-model="people"
          :possibleValues="possibleInhabitants"
          slider
          required
        ></SimulationField>
        <SimulationField
          :label="$t('Situation.Consumption.consumptionUnknown.houseSize.title')"
          v-model="houseSize"
          :possibleValues="possibleHouseSizes"
          slider
          required
        ></SimulationField>
        <SimulationField
          :label="$t('Situation.Consumption.consumptionUnknown.occupation.title')"
          v-model="occupation"
          :possibleValues="possibleOccupations"
          radio
          required
        ></SimulationField>
        <SimulationField
          :label="$t('Situation.Consumption.consumptionUnknown.heating.title')"
          v-model="heating"
          :possibleValues="possibleHeaterTypes"
          radio
          required
        ></SimulationField>
        <SimulationField
          :label="$t('Situation.Consumption.consumptionUnknown.water.title')"
          v-model="water"
          :possibleValues="possibleWaterTypes"
          radio
          required
        ></SimulationField>
        <SimulationField
          :label="$t('Situation.Consumption.consumptionUnknown.homeAppliance.title')"
          v-model="homeAppliance"
          :possibleValues="possibleHomeAppliances"
        ></SimulationField>
        <SimulationField
          :label="$t('Situation.Consumption.consumptionUnknown.others.title')"
          v-model="others"
          :possibleValues="possibleOthers"
          v-if="possibleOthers.length > 0"
        ></SimulationField>
      </div>
        <div class="buttons inline">
          <button class="button main" @click="close()">{{ $t('back') }}</button>
          <button class="button main" @click="calculate()">{{ $t('validate') }}</button>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import BecomeField from "@/components/Form/BecomeField";
import SimulationField from "@/components/Form/SimulationField.vue";
import { mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapState("consumption", ["dishwasher", "dryer", "washingMachine", "electricCar", "battery"]),
    ...mapGetters("subscription", ["isTestAchat"]),
    possibleHouseSizes() {
      return [
        { label: '25m²' ,longLabel: this.$t('Situation.Consumption.consumptionUnknown.houseSize.25'), icon: "1-area" },
        { label: '50m²', longLabel: this.$t('Situation.Consumption.consumptionUnknown.houseSize.50'), icon: "2-area" },
        { label: '75m²', longLabel: this.$t('Situation.Consumption.consumptionUnknown.houseSize.75'), icon: "3-area" },
        { label: '100m²', longLabel: this.$t('Situation.Consumption.consumptionUnknown.houseSize.100'), icon: "3-area" },
        { label: '150m²', longLabel: this.$t('Situation.Consumption.consumptionUnknown.houseSize.150'), icon: "3-area" },
        { label: '200m²', longLabel: this.$t('Situation.Consumption.consumptionUnknown.houseSize.200'), icon: "3-area" },
        { label: '250m²', longLabel: this.$t('Situation.Consumption.consumptionUnknown.houseSize.200+'), icon: "3-area" },
      ]
    },
    possibleOccupations() {
      return [
        {
          label: this.$t('Situation.Consumption.consumptionUnknown.occupation.summer'),
          value: "summer",
          icon: "occupation-summer"
        },
        {
          label: this.$t('Situation.Consumption.consumptionUnknown.occupation.evening_weekend'),
          value: "evening_weekend",
          icon: "occupation-evening_weekend",
        },
        {
          label: this.$t('Situation.Consumption.consumptionUnknown.occupation.weekend_holidays'),
          value: "weekend_holidays",
          icon: "occupation-weekend_holidays",
        },
        {
          label: this.$t('Situation.Consumption.consumptionUnknown.occupation.always'),
          value: "always",
          icon: "occupation-always"
        },
      ]
    },
    possibleHeaterTypes() {
      return [
        { label: this.$t('Situation.Consumption.consumptionUnknown.heating.elec'), value: "elec", icon: "heater-elec" },
        { label: this.$t('Situation.Consumption.consumptionUnknown.heating.gas'), value: "gas", icon: "heater-gas" },
        { label: this.$t('Situation.Consumption.consumptionUnknown.heating.pump'), value: "heat_pump", icon: "heater-pump" },
        { label: this.$t('Situation.Consumption.consumptionUnknown.heating.other'), value: "other", icon: "heater-other" },
      ]
    },
    possibleWaterTypes() {
      return [
        { label: this.$t('Situation.Consumption.consumptionUnknown.water.elec'), value: "elec", icon: "water-elec" },
        { label: this.$t('Situation.Consumption.consumptionUnknown.water.gas'), value: "gas", icon: "water-gas" },
        { label: this.$t('Situation.Consumption.consumptionUnknown.water.other'), value: "other", icon: "water-other" },
      ]
    },
    possibleHomeAppliances() {
       return [
        {
          label: this.$t('Situation.Consumption.consumptionUnknown.homeAppliance.dishwasher'),
          value: "dishwasher",
          icon: "appliance-dishwasher",
        },
        {
          label: this.$t('Situation.Consumption.consumptionUnknown.homeAppliance.dryer'),
          value: "dryer",
          icon: "appliance-dryer" },
        {
          label: this.$t('Situation.Consumption.consumptionUnknown.homeAppliance.washingMachine'),
          value: "washingMachine",
          icon: "appliance-washingmachine",
        },
      ];
    },
    possibleOthers() {
      let possible = []
      if (this.$store.state.contract.energies == 'elec' || this.$store.state.contract.energies == 'dual')
        possible.push({
          label: this.$t('Situation.Consumption.consumptionUnknown.others.electricCar'),
          value: "electricCar",
          icon: "electric-car"
        })
      if ((this.$store.state.contract.energies == 'elec' || this.$store.state.contract.energies == 'dual')
        && (this.$store.state.contract.address.locality.region == 'vl' || this.$store.state.contract.address.locality.region == 'bx')
        && this.$store.state.contract.electricity.solarPanel
        && this.$store.state.contract.electricity.meter.injection)
        possible.push({
          label: this.$t('Situation.Consumption.consumptionUnknown.others.battery'),
          value: "battery",
          icon: "home-battery"
        })
      return possible
    },
    possibleInhabitants() {
      let possibleInhabitants = [];

      for (let i = 1; i < 8; i++) {
        let icon = i < 5 ? `${i}-inhabitant` : `4-inhabitant`;
        let label = i < 7 ? `${i}` : "7+";
        possibleInhabitants.push({ label: label, icon: icon });
      }

      return possibleInhabitants;
    },
    occupation: {
      get() {
        return this.$store.state.consumption.occupation;
      },
      set(value) {
        this.$store.commit("consumption/setOccupation", value);
      },
    },
    people: {
      get() {
        return this.$store.state.consumption.inhabitants;
      },
      set(value) {
        this.$store.commit("consumption/setInhabitants", value);
        this.$store.commit("contract/setInhabitants", value);
      },
    },
    houseSize: {
      get() {
        return this.$store.state.consumption.houseSize;
      },
      set(value) {
        this.$store.commit("consumption/setHouseSize", value);
      },
    },
    heating: {
      get() {
        return this.$store.state.consumption.heating;
      },
      set(value) {
        this.$store.commit("consumption/setHeating", value);
      },
    },
    water: {
      get() {
        return this.$store.state.consumption.water;
      },
      set(value) {
        this.$store.commit("consumption/setWater", value);
      },
    },
    homeAppliance: {
      get() {
        let homeAppliance = [];
        if (this.dishwasher) homeAppliance.push("dishwasher");
        if (this.dryer) homeAppliance.push("dryer");
        if (this.washingMachine) homeAppliance.push("washingMachine");

        return homeAppliance;
      },
      set(value) {
        this.$store.commit("consumption/setDishwasher", value.indexOf('dishwasher') !== -1);
        this.$store.commit("consumption/setDryer", value.indexOf('dryer') !== -1);
        this.$store.commit("consumption/setWashingMachine", value.indexOf('washingMachine') !== -1);
      }
    },
    others: {
      get() {
        let others = [];
        if (this.electricCar) others.push("electricCar");
        if (this.battery) others.push("battery");

        return others;
      },
      set(value) {
        this.$store.commit("consumption/setElectricCar", value.indexOf('electricCar') !== -1);
        this.$store.commit("consumption/setBattery", value.indexOf('battery') !== -1);
      }
    },
  },
  methods: {
    async calculate() {
      await this.$store.dispatch("consumption/getEstimation");
      this.close();
    },
    close() {
      this.$emit('close');
      document.body.classList.remove("modal-open");
    }
  },
  created() {
    document.body.classList.add("modal-open");
  },
  components: {
    BecomeField,
    SimulationField,
  },
}
</script>

<style lang="scss" scoped>
.TA {
  .modal {
    .form-field { 
      /deep/ div > h1 {
        background-color: transparent!important;
        color: $black!important;
        text-transform: capitalize!important;
      }
    }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/Situation/SituationContext/Estimation.vue